import React, { useEffect, useState } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

const Footer = () => {
  const NAV_WIDTH = 350;

  const footerStyle = {
    backgroundColor: 'rgba(240, 240, 240, 0.7)',
    padding: '10px',
    textAlign: 'center',
    position: 'fixed',
    bottom: 0,
    width: '100%',
    height: '40px', // Set the height to 100px
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backdropFilter: 'blur(5px)',
  };
  const itemStyle = {
    margin: '0 10px', // Add margin between items
    height: '20px'
  };

  const { t } = useTranslation();

  function handleClickLang(lang) {
    i18next.changeLanguage(lang);
  }
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  const handleClickLangs = (language) => {
    setSelectedLanguage(language);
    i18next.changeLanguage(language);
    // You can perform additional actions based on the selected language here
  };

  return (
    <footer style={footerStyle}>
      {/* Normal anchor tag for external links */}
      <a href="https://chainsmart.id" target="_blank" rel="noopener noreferrer" style={{ paddingLeft: '18em' }}>
        &copy; 2024 ChainSmart - All Rights Reserved
      </a>
      <ToggleButtonGroup
        style={itemStyle}
        color="primary"
        value={selectedLanguage}
        exclusive
        aria-label="Language Toggle"
      >
        <ToggleButton value="en" onClick={() => handleClickLangs('en')}>
          EN
        </ToggleButton>
        <ToggleButton value="id" onClick={() => handleClickLangs('id')}>
          ID
        </ToggleButton>
      </ToggleButtonGroup>
    </footer>
  );
};

export default Footer;
